import { useEffect, useState } from 'react';

const useOutsideColorPickerClick = (ref, callback) => {
  const [isStartClickOnPicker, setIsStartClickOnPicker] = useState(false);

  const handleClick = e => {
    if (ref.current && !ref.current.contains(e.target) && !isStartClickOnPicker) {
      callback();
    }
  };

  const handleCheck = event => {
    const eventPath = event?.path || event?.composedPath();
    const isReactColorfulClick = eventPath?.some(({ classList = [] }) =>
      Object.values(classList).some(name => name?.includes('react-colorful'))
    );

    setIsStartClickOnPicker(isReactColorfulClick);
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleCheck);
    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
      document.addEventListener('mousedown', handleCheck);
    };
  });
};

export default useOutsideColorPickerClick;
